var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro"},[(_vm.bigText)?_c('div',{staticClass:"bigtext"},[_vm._v(_vm._s(_vm.bigText))]):_vm._e(),(_vm.smallText)?_c('div',{staticClass:"smalltext"},[_vm._v(_vm._s(_vm.smallText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }